import { MARKET_NEWS, MARKET_NEWS_ERROR, MARKET_NEWS_HIDE_ERROR, MARKET_NEWS_START_LOADER, MARKET_NEWS_STOP_LOADER } from "../interface/iMarketNews";
const initialState = {
    marketNewsData: [],
    marketNewsLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const marketNewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case MARKET_NEWS:
            return Object.assign(Object.assign({}, state), { marketNewsData: action.payload.data });
        case MARKET_NEWS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MARKET_NEWS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case MARKET_NEWS_START_LOADER:
            return Object.assign(Object.assign({}, state), { marketNewsLoader: true });
        case MARKET_NEWS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { marketNewsLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default marketNewsReducer;
